<template>
  <b-overlay :show="loading">
    <validation-observer ref="newUserForm" #default="{invalid}">
      <b-form ref="form" @submit.prevent="createNewUser">
        <b-row>
          <b-col cols="12" xl="6" md="6">
            <b-card no-body class="">
              <b-row class="mt-2">
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="First Name"
                      label-for="first_name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="First Name"
                          rules="required"
                        >
                          <b-form-input 
                            id="first_name" 
                            v-model="newUserData.first_name" 
                            placeholder="John"
                            :state="errors.length > 0 ? false : null"
                            />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
  
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Last Name"
                      label-for="last_name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Last Name"
                          rules="required"
                        >
                          <b-form-input 
                            id="last_name" 
                            v-model="newUserData.last_name" 
                            placeholder="Doe"
                            :state="errors.length > 0 ? false : null"
                            />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Gender"
                      label-for="gender"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Gender"
                        rules="required"
                      >
                        <v-select
                          id="gender"
                          placeholder="Gender"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :value="newUserData.gender"
                          :options="genderOptions"
                          :reduce="val => val.value"
                          :disabled="loading"
                          @input="(val) => newUserData.gender = val"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
  
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Date of Birth"
                      label-for="date_of_birth"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Date of Birth"
                          rules="required"
                        >
                          <cleave 
                            v-model="newUserData.date_of_birth"
                            :raw="false"
                            :options="cleaveDateOptions"
                            autocomplete="off"
                            class="form-control"
                            name="date of birth"
                            placeholder="YYYY-MM-DD"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Phone"
                      label-for="phone"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Phone"
                        rules="required"
                        vid="phone"
                      >
                        <b-form-input
                          id="phone"
                          v-model="newUserData.phone"
                          :state="errors.length > 0 ? false:null"
                          name="register-phone"
                          placeholder="0201234567"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>

                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Email"
                      label-for="email"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        rules="required|email"
                        vid="email"
                      >
                        <b-form-input
                          id="email"
                          v-model="newUserData.email"
                          :state="errors.length > 0 ? false:null"
                          name="email"
                          placeholder="john@example.com"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Member Type"
                      label-for="member_type"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Member Type"
                          rules="required"
                        >
                          <v-select
                            class=""
                            placeholder="Member type"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :value="newUserData.member_type_id"
                            :options="member_types"
                            :reduce="val => val.value"
                            :disabled="loading"
                            @input="(val) => newUserData.member_type_id = val"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
  
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Member Title"
                      label-for="member_title"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Member Title"
                          rules="required"
                        >
                          <v-select
                            class=""
                            placeholder="Member Title"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :value="newUserData.member_title_id"
                            :options="memberTitleOptions"
                            :reduce="val => val.value"
                            :disabled="loading"
                            @input="(val) => newUserData.member_title_id = val"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Member Designation"
                      label-for="member_designation"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Member Designation"
                          rules="required"
                        >
                          <v-select
                            class=""
                            placeholder="Member type"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :value="newUserData.member_designation_id"
                            :options="memberDesignationOptions"
                            :reduce="val => val.value"
                            :disabled="loading"
                            @input="(val) => newUserData.member_designation_id = val"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
  
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Department"
                      label-for="department"
                      >
                          <v-select
                            class=""
                            placeholder="Department"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            v-model="newUserData.department_id"
                            :options="departmentOptions"
                            :reduce="val => val.value"
                            :disabled="loading"
                          />
                    </b-form-group>
                  </b-card-body>
                </b-col>
              </b-row>

              <div v-if="newUserData.country === 'Ghana'">
                <b-row>
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="Region"
                        label-for="region"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Region"
                            rules="required"
                          >
                            <v-select
                              id="region"
                              v-model="newUserData.region_id"
                              placeholder="Region"
                              :loading="loading"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                              :options="regionOptions"
                              :reduce="(val) => val.value"
                              :clearable="false"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
    
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="Area"
                        label-for="area"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Area"
                            rules="required"
                          >
                            <v-select
                              id="area"
                              v-model="newUserData.area_id"
                              placeholder="Area"
                              :loading="loading"
                              :clearable="false"
                              :options="areaOptions"
                              :reduce="(val) => val.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
                </b-row>
  
                <b-row>
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="District"
                        label-for="district"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="District"
                            rules="required"
                          >
                            <v-select
                              id="district"
                              v-model="newUserData.district_id"
                              placeholder="District"
                              :loading="loading"
                              :clearable="false"
                              :options="districtOptions"
                              :reduce="(val) => val.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
    
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="Assembly"
                        label-for="assembly"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Assembly"
                            rules="required"
                          >
                            <v-select
                              id="assembly"
                              v-model="newUserData.assembly_id"
                              placeholder="Assembly"
                              :loading="loading"
                              :clearable="false"
                              :options="assemblyOptions"
                              :reduce="(val) => val.value"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
                </b-row>
              </div>

              <div v-if="newUserData.country !== 'Ghana'">
                <b-row>
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="Region"
                        label-for="region"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Region"
                          rules="required"
                        >
                          <b-form-input 
                            id="region" 
                            v-model="newUserData.region" 
                            placeholder="Region"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
    
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="Area"
                        label-for="area"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Area"
                          rules="required"
                        >
                          <b-form-input 
                            id="area" 
                            v-model="newUserData.area" 
                            placeholder="Area"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
                </b-row>
  
                <b-row>
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="District"
                        label-for="district"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="District"
                          rules="required"
                        >
                          <b-form-input 
                            id="district" 
                            v-model="newUserData.district" 
                            placeholder="District"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
    
                  <b-col>
                    <b-card-body class="pt-0">
                      <b-form-group
                        label="Assembly"
                        label-for="assembly"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Assembly"
                          rules="required"
                        >
                          <b-form-input 
                            id="assembly" 
                            v-model="newUserData.assembly" 
                            placeholder="Assembly"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-card-body>
                  </b-col>
                </b-row>
              </div>
              
              <b-row class="mt-1" v-if="isCopMinister">
                <b-col cols="12" md="6">
                  <b-card-body class="pt-0">
                    <validation-provider #default="{ errors }" name="Minister Id" :rules="isCopMinister ? 'required' : ''">
                      <b-form-group label="Minister Id" label-for="minister_id">

                        <b-form-input 
                          id="minister_id" 
                          v-model="newUserData.minister_id" 
                          placeholder="Minister Id"
                          :state="errors.length > 0 ? false:null"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-card-body>
                </b-col>

                <b-col cols="12" md="6">
                  <b-card-body class="pt-0">
                    <validation-provider #default="{ errors }" name="Year Called Into Ministry" :rules="isCopMinister ? 'required' : ''">
                      <b-form-group label="Year Called Into Ministry" label-for="area"> 

                        <b-form-input 
                          id="year_called_into_ministry" 
                          v-model="newUserData.year_called_into_ministry" 
                          placeholder="Year called into ministry"
                          :state="errors.length > 0 ? false:null"
                        />
                        
                        <small class="text-danger">{{ errors[0] }}</small>
                      </b-form-group>
                    </validation-provider>
                  </b-card-body>
                </b-col>
              </b-row>

              <b-row>  
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="Country"
                      label-for="country"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Country"
                          rules="required"
                        >
                          <v-select
                            id="country"
                            placeholder="Country"
                            :value="newUserData.country"
                            :loading="loading"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="countryOptions"
                            :reduce="(val) => val.value"
                            :clearable="false"
                            @input="(val) => newUserData.country = val"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>

                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group label="User Roles" label-for="user_roles">
                      <validation-provider
                        #default="{ errors }"
                        name="User Roles"
                        rules=""
                      >
                        <v-select
                          v-model="newUserData.user_roles"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="userRoleOptions"
                          :reduce="(val) => val.value"
                          :clearable="true"
                          :close-on-select="false"
                          multiple
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-card-body class="pt-0">
                    <b-form-group
                      label="User Permission Policies"
                      label-for="user_role"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="User Permission Policies"
                          rules=""
                        >
                          <v-select
                            v-model="newUserData.permissions"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="policyOptions"
                            :reduce="val => val.value"
                            :clearable="true"
                            :close-on-select="false"
                            multiple
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                  </b-card-body>
                </b-col>
              </b-row>

              <b-button
                class="mb-5 mx-2"
                style="width: 150px"
                variant="primary"
                block
                type="submit"
                :disabled="invalid || loading"
              >
                Create User
              </b-button>
            </b-card>
          </b-col>
        </b-row>
        
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { 
  BOverlay, BRow, BCol, BCard, BCardBody, BButton, 
  BFormGroup, BForm, BFormInput
} from 'bootstrap-vue'

import { required, email } from '@validations'
import { get, cloneDeep, omit } from 'lodash';

import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const rawUserData = {
  first_name: "",
  last_name: "",
  permissions: "",
  member_type_id: "",
  member_title_id: "",
  minister_id: "",
  year_called_into_ministry: "",
  member_designation_id: "",
  department_id: "",
  region_id: "",
  region: "",
  gender: "",
  date_of_birth: "",
  area_id: "",
  area: "",
  district_id: "",
  district: "",
  assembly_id: "",
  assembly: "",
  country: "Ghana",
  email: "",
  phone: "",
  user_roles: []
}

const memberTitlesAndDesignationCachedData = []

export default {
  components: {
    vSelect,
    BOverlay, 
    BRow, 
    BCol, 
    BCard, 
    BCardBody, 
    BButton,
    BFormGroup, 
    BForm, 
    BFormInput,
    Cleave,

    // validations
    ValidationProvider,
    ValidationObserver,
  },
  data(){
    return {
      loading: false,
      errorMessage: '',
      newUserData: cloneDeep(rawUserData),
      userTypeOptions: [],
      policyOptions: [],
      userRoleOptions: [],
      member_types: [],
      memberTitleOptions: [],
      memberDesignationOptions: [],
      departmentOptions: [],
      regionOptions: [],
      countryOptions: [],
      areaOptions: [],
      districtOptions: [],
      assemblyOptions: [],
      genderOptions: [
        {
          value: "female",
          label: "Female",
        },
        {
          value: "male",
          label: "Male",
        },
      ],
      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: '-',
        datePattern: ['Y', 'm', 'd'],
        blocks: [4, 2, 2],
      },

      // validation rules
      required,
      email
    }
  },
  computed: {
    isCopMinister() {
      const selected_member_type = this.member_types.find(
        (member_type) => member_type.value === this.newUserData.member_type_id
      );
      
      return selected_member_type ? selected_member_type.is_cop_minister : false;
    }
  },
  watch: {
    "newUserData.member_type_id": {
      handler(member_type_id) {
        if (member_type_id) {
          this.newUserData.member_title_id = "";
          this.newUserData.member_designation_id = "";

          const existingTitleAndDesignationIndex = memberTitlesAndDesignationCachedData.findIndex(i => i.id === this.newUserData.member_type_id)
          console.log('existingTitleAndDesignationIndex', existingTitleAndDesignationIndex)

          if (existingTitleAndDesignationIndex >= 0) {
            this.memberTitleOptions = memberTitlesAndDesignationCachedData[existingTitleAndDesignationIndex].titles; 
            this.memberDesignationOptions = memberTitlesAndDesignationCachedData[existingTitleAndDesignationIndex].designations; 

            return;
          }
          
          this.fetchMemberTitlesAndDesignations(member_type_id)
        }
      },
      immediate: true
    },
    "newUserData.region_id": {
      handler(changed) {
        if (changed) {
          if (this.newUserData.country !== "Ghana") {
            return;
          }
          this.fetchChurchAreas();
        }
      },
      immediate: true,
    },
    "newUserData.area_id": {
      handler(changed) {
        if (changed) {
          if (this.newUserData.country !== "Ghana") {
            return;
          }
          this.fetchChurchDistrict();
        }
      },
      immediate: true,
    },
    "newUserData.district_id": {
      handler(changed) {
        console.log("userData", this.newUserData)
        if (changed) {
          if (this.newUserData.country !== "Ghana") {
            return;
          }
          this.fetchChurchAssemblies();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.fetchCountries();
    this.fetchPermissions();
    this.fetchAdminRoles();
    this.fetchMemberTypes();
    this.fetchDepartments();
    this.fetchChurchRegions();
  },
  methods: {
    async fetchPermissions() {
      try {
        this.loading = true; 

        const query = {
          limit: 1000,
          page: 1
        }

        const response = await this.useJwt().mainService.policy.list(query);
        this.policyOptions = get(response, 'data.data', []).map(pm => ({ ...pm, label: pm.name, value: pm._id }))
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async createNewUser(){
      try {
        this.loading = true;
        this.errorMessage = '';
        
        const success = await this.$refs.newUserForm.validate();
        if (!success){ return; }

         let policies = [];
         let roles = [];


        if (this.newUserData.permissions.length){
           policies = this.newUserData.permissions.map(permission_id => ({ permission_id, permission_type: "policy" }))
        }

        if (this.newUserData.user_roles){
           roles = this.newUserData.user_roles.map(permission_id => ({ permission_id, permission_type: "role" }))
        }

        // Remove fields based on country
        const fieldsToOmit = ['user_roles'];
        if (this.newUserData.country === 'Ghana') {
          // For Ghana, remove text fields and keep ID fields
          fieldsToOmit.push('region', 'area', 'district', 'assembly');
        } else {
          // For other countries, remove ID fields and keep text fields
          fieldsToOmit.push('region_id', 'area_id', 'district_id', 'assembly_id');
        }

        await this.useJwt().mainService.users.create({ ...omit(this.newUserData, fieldsToOmit), permissions: [ ...policies, ...roles ] });
        this.resetForm();
    
        await this.$router.push({ name: "users" });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success',
            icon: 'EditIcon',
            variant: 'success',
            text: `User created successfully. A password reset link will be sent to their email address.`
          },
        });
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async fetchAdminRoles() {
      try {
        this.loading = true;

        const query = {
          limit: 1000,
          page: 1,
        };

        const response = await this.useJwt().mainService.userRoles.list(query);
        this.userRoleOptions = get(response, "data.data", []).map((pm) => ({
          ...pm,
          label: pm.title,
          value: pm._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTypes() {
      try {
        this.loading = true;

        const query = {
          limit: 1000,
        }

        const request = await this.useJwt().mainService.memberTypes.list(query);
        const { data } = request.data;

        this.member_types = data.map((member_type) => ({
          label: member_type.title,
          value: member_type._id,
          is_cop_minister: member_type.is_cop_minister
        }));
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchMemberTitlesAndDesignations(member_type_id) {
      try {
        const query = {
          member_type_id
        }
        const member_title_resp = await this.useJwt().mainService.memberTitles.list(query);
        const member_designation_rep = await this.useJwt().mainService.memberDesignations.list(query);
        const member_titles = get(member_title_resp.data, 'data.[0].categories')
        const member_designations = get(member_designation_rep.data, 'data.[0].categories')

        this.memberTitleOptions = member_titles.map((member_title) => ({
          label: member_title.title,
          value: member_title._id,
        }));

        this.memberDesignationOptions = member_designations.map((member_designation) => ({
          label: member_designation.designation,
          value: member_designation._id,
        }));

        memberTitlesAndDesignationCachedData.push({ 
          id: this.newUserData.member_type_id, 
          titles: this.memberTitleOptions, 
          designations: this.memberDesignationOptions 
        })
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
          console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchDepartments() {
      try {
        const response = await this.useJwt().sharedService.fetchDepartments();

        const departments = get(response, "data");
        
        this.departmentOptions = departments.map((department) => ({
          value: department._id,
          label: department.title,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
        this.newUserData.region_id = "";
        this.newUserData.area_id = "";
        this.newUserData.district_id = "";
        this.newUserData.assembly_id = "";
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAreas() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoAreas(
          { region_id: this.newUserData.region_id }
        );
        const { data } = request.data;
        this.areaOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));

        this.newUserData.area_id = "";
        this.newUserData.district_id = "";
        this.newUserData.assembly_id = "";
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchDistrict() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoDistricts(
          { area_id: this.newUserData.area_id }
        );
        const { data } = request.data;
        this.districtOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));

        this.newUserData.district_id = "";
        this.newUserData.assembly_id = "";
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblies() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoAssemblies(
          { district_id: this.newUserData.district_id }
        );
        const { data } = request.data;
        this.assemblyOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));

        this.newUserData.assembly_id = "";
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchCountries() {
      try {
        const response = await this.useJwt().sharedService.fetchCountries();

        const countries = get(response, "data.data");
        this.countryOptions = countries.map((country) => ({
          label: country.country,
          value: country.country,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    resetForm(){
      Object.keys(cloneDeep(this.newUserData)).forEach(key => {
        const resetValue = get(rawUserData, key);
        this.newUserData[key] = resetValue
        this.$set(this.newUserData, resetValue)
      });
    }
  }
}
</script>
